var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed__container button-container"},[(_vm.isSubPage)?_c('span',{staticClass:"back__link flex",on:{"click":_vm.reload}},[_c('Back'),_vm._v(" Powrót\n    ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }